// T4/100A01: con REACT_APP_UI_SIDEBAR_COLAPSABLE=true los submódulos muestran el
// menú lateral oculto (barra de iconos) en escritorio. Sin la variable, o en
// celular (el menú va en el cajón de Navbar), el render es el original.
import React from "react";
import { Layout } from "antd";
import Footer from "components/Footer";
import Navbar from "components/Navbar";
import BodySidebar from "components/layout/BodySidebar";
import { SIDEBAR_COLLAPSIBLE } from "config/featureFlags";
import useIsMobile from "Hooks/useIsMobile";

export default function Body(props) {
  const isMobile = useIsMobile();
  // T4/100A03: con la variable, en celular el contenido también lleva márgenes responsive. Antes
  // en celular caía al render original (sin márgenes).
  if (SIDEBAR_COLLAPSIBLE && isMobile) {
    return (
      <>
        <Layout style={{ minHeight: "100%" }}>
          <Navbar>{props.navbar_content}</Navbar>
          {/* T4/100A04: + menú lateral colapsable en celular. Antes solo el contenido. */}
          <div className="jag-body-with-sidebar">
            <BodySidebar />
            <div className="jag-body-content" style={props.style_content}>
              {props.children}
            </div>
          </div>
        </Layout>
        <Footer />
      </>
    );
  }
  if (SIDEBAR_COLLAPSIBLE && !isMobile) {
    return (
      <>
        <Layout style={{ minHeight: "100%" }}>
          <Navbar>{props.navbar_content}</Navbar>
          <div className="jag-body-with-sidebar">
            <BodySidebar />
            <div className="jag-body-content" style={props.style_content}>
              {props.children}
            </div>
          </div>
        </Layout>
        <Footer />
      </>
    );
  }
  return (
    <>
      <Layout style={{ minHeight: "100%" }}>
        <Navbar>{props.navbar_content}</Navbar>
        <div style={props.style_content}>{props.children}</div>
      </Layout>
      <Footer />
    </>
  );
}
